import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Modal, Button } from 'antd';
import { saveSearchParams } from '../../../actions/noticeActions';
import { saveParams } from '../../../actions/homeActions';

class NewsRemind extends Component {
    hideExpectHour = () => {
        this.props.saveParams({ expectHour: false });
        this.props.saveSearchParams({ noticeType: undefined, noticeValue: undefined, activeKey:undefined });
    }

    viewDetail = () => {
        this.props.saveParams({ expectHour: false });
        this.props.saveSearchParams({ 
            noticeType: 'PLAN_FTE_ADJUSTMENT', 
            noticeValue:'预计工时调整提醒', 
            activeKey:'Notice',  
        });
        location.href = './#/notice';
    }
    
    viewDetailCenter = () => {
        this.props.saveParams({ centerRelate: false });
        this.props.saveSearchParams({
            noticeType: 'CONTRACT_RELATE_SITE',
            noticeValue:'中心关联合同通知',
            activeKey:'Backlog',
        });
        location.href = './#/notice';
    }

    ViewInfoConfirm = () => {
        this.props.saveParams({ infoConfirm: false });
        this.props.saveSearchParams({ 
            noticeType: 'SSU_HOSPITAL_INFO_CONFIRM', 
            noticeValue:'办事流程确认提醒', 
            activeKey:'Backlog',
        });
        location.href = './#/notice';
    }

    render() {
        const { params: { expectHour = false, centerRelate = false, infoConfirm } } = this.props;
        return (
            <div>
            <Modal
                title="预计工时调整提醒"
                visible={expectHour}
                onCancel={this.hideExpectHour}
                className="preview-modal"
                wrapClassName="vertical-center-modal"
                maskClosable={false}
                width="400px"
                footer={<Button type="primary" onClick={this.viewDetail}>查看详情</Button>}
            >
                <div style={{ padding: '30px 40px' }}>
                    你负责的项目签署了补充合同，请确认是否需要调整预计工时
                </div>
            </Modal>
            <Modal
                title="中心与合同关联提醒"
                closable={false}
                visible={centerRelate}
                className="preview-modal"
                wrapClassName="vertical-center-modal"
                maskClosable={false}
                width="400px"
                footer={<Button type="primary" onClick={this.viewDetailCenter}>查看详情</Button>}
            >
                <div style={{ padding: '30px 40px' }}>
                    你负责的项目签署了新合同号，请及时进行中心与合同关联
                </div>
            </Modal>
            <Modal
                title="办事流程确认提醒"
                visible={infoConfirm}
                closable={false}
                className="preview-modal"
                wrapClassName="vertical-center-modal"
                maskClosable={false}
                width="400px"
                footer={<Button type="primary" onClick={this.ViewInfoConfirm}>查看详情</Button>}
            >
                <div style={{ padding: '30px 40px' }}>
                    您所负责的部分医院办事流程还未确认,请及时处理
                </div>
            </Modal>
            </div>
        )
    }
}

const mapSateToProps = (state) => ({
    params: state.homeState.params || {},
});

const mapDispatchToProps = (dispatch) => {
    return {
        saveParams: (params) => dispatch(saveParams(params)),
        saveSearchParams: (params) => dispatch(saveSearchParams(params))
    }
}

export default connect(mapSateToProps, mapDispatchToProps)(NewsRemind);


// WEBPACK FOOTER //
// ./src/components/homePage/afficheNews/NewsRemind.js